import React from 'react';
import { CenterFrameLayout } from 'Layouts';
import ProfileSignIn from './ProfileSignIn';

const SignInLayoutV1 = (props) => {
  return (
    <CenterFrameLayout customClass="giftCardSignIn" title="Sign In To Redeem">
      <div className="centerForm">
        <ProfileSignIn {...props} />
      </div>
    </CenterFrameLayout>
  );
};

export default SignInLayoutV1;
